export default __webpack_public_path__ + "static/media/like-outlined.634f70a1.svg";